import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskCartFunnelRadioOptionBlockConfig } from '@front-platform/content-builder';
import { kioskCartFunnelRadioOptionBlockResolveConfig } from '@front-platform/content-builder';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface KioskCartFunnelRadioOptionBlockRuntimeConfig {
  'parent_id'?: string;
  'text_color'?: IContentBuilderFieldColor | undefined;
  'button_color'?: IContentBuilderFieldColor | undefined;
  'active_text_color'?: IContentBuilderFieldColor | undefined;
  'active_button_color'?: IContentBuilderFieldColor | undefined;
}

export type KioskCartFunnelRadioOptionBlockConfigInput = Partial<
  Omit<KioskCartFunnelRadioOptionBlockConfig, keyof KioskCartFunnelRadioOptionBlockRuntimeConfig> &
    KioskCartFunnelRadioOptionBlockRuntimeConfig
>;
export type KioskCartFunnelRadioOptionBlockResolvedConfig = Omit<
  KioskCartFunnelRadioOptionBlockConfig,
  keyof KioskCartFunnelRadioOptionBlockRuntimeConfig
> &
  Partial<KioskCartFunnelRadioOptionBlockRuntimeConfig>;
export interface KioskCartFunnelRadioOptionBlockContract extends ConfigComponentContract<
  KioskCartFunnelRadioOptionBlockConfigInput,
  KioskCartFunnelRadioOptionBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-cart-funnel-radio-option-block',
  templateUrl: './kiosk-cart-funnel-radio-option-block.component.html',
  standalone: false,
})
export class KioskCartFunnelRadioOptionBlockComponent
  implements OnInit, OnDestroy, KioskCartFunnelRadioOptionBlockContract
{
  readonly config = input<KioskCartFunnelRadioOptionBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskCartFunnelRadioOptionBlockConfig,
    KioskCartFunnelRadioOptionBlockRuntimeConfig
  >(kioskCartFunnelRadioOptionBlockResolveConfig, () => ({ config: this.config() }));
  private _destroyerRef = new Subject<boolean>();

  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get value(): string {
    return this.resolvedConfig()['value'] as unknown as string;
  }
  get parentId(): string {
    return this.resolvedConfig()['parent_id'] as unknown as string;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get buttonColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['button_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get activeTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['active_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get activeButtonColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['active_button_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  isActive = false;

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelSelector
      .selectValue(this.parentId)
      .pipe(
        takeUntil(this._destroyerRef),
        map(input => input?.value === this.value),
      )
      .subscribe(_isActive => {
        this.isActive = _isActive;
      });
  }

  ngOnDestroy(): void {
    this._destroyerRef.next(true);
    this._destroyerRef.complete();
  }

  onValueChange(_value: boolean | string): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.parentId,
      changes: {
        value: _value,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskCartFunnelRadioOptionBlockComponent, {
  'keyAliases': {},
});
